import React from 'react';
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportContent from "./content/report-content.jsx";

const Content = ({reportData, data, boName, boId, printOptions, entity, collapsed, printComponentRef, setLoading, individualList}) => {
    return (
        <>
            {
                reportData && data > 0 && (
                    <PrintTemplate entity={entity} title={null} ref={printComponentRef} setIsPrinting={setLoading} setLoading={setLoading} printHeaderClassname={'print:relative print:!z-[998] print:!bg-white print:!pb-[2px]'} printFooterClassname={'print:bg-white! print:pb-5! print:!transform print:!translate-y-[0.75px]'}>
                        <div className={"w-full mt-[25px] print:mt-[0]"}>
                            <ReportContent
                                data={reportData}
                                collapsed={collapsed}
                                printOptions={printOptions}
                                boId={boId}
                                boName={boName}
                                individualList={individualList}
                            />
                        </div>
                    </PrintTemplate>
                )
            }
        </>
    );
};

export default Content;